import createCrudVuexModule from "@/store/crud";

export const disposalMethod = createCrudVuexModule({
  namespaced: true,
  path: "/library/disposal-method",
});

export const workspaceDisposalMethod = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/disposal-method",
});

export const managementDisposalMethod = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/disposal-method",
});

// ----------------------------------------

export const physicalStorageCategory = createCrudVuexModule({
  namespaced: true,
  path: "/library/physical-storage-category",
});

export const workspacePhysicalStorageCategory = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/physical-storage-category",
});

export const managementPhysicalStorageCategory = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/physical-storage-category",
});

// ----------------------------------------------

export const physicalStorage = createCrudVuexModule({
  namespaced: true,
  path: "/library/physical-storage",
});

export const workspacePhysicalStorage = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/physical-storage",
});

export const managementPhysicalStorage = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/physical-storage",
});

// ----------------------------------------------

export const electronicStorage = createCrudVuexModule({
  namespaced: true,
  path: "/library/electronic-storage",
});

export const workspaceElectronicStorage = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/electronic-storage",
});

export const managementElectronicStorage = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/electronic-storage",
});
// ----------------------------------------------

export const electronicStorageCategory = createCrudVuexModule({
  namespaced: true,
  path: "/library/electronic-storage-category",
});

export const workspaceElectronicStorageCategory = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/electronic-storage-category",
});

export const managementElectronicStorageCategory = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/electronic-storage-category",
});
